export default __webpack_public_path__ + "static/media/selectedcase.a7456af0.svg";